import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { REFLECTION_FEATURE_KEY } from './keys';
import { reflectionReducer } from './reducers/reflection.reducer';
import { ReflectionEffects } from './effects/reflection.effects';

export function provideReflectionStore(): EnvironmentProviders[] {
    return [provideState(REFLECTION_FEATURE_KEY, reflectionReducer), provideEffects(ReflectionEffects)];
}
